import { ref, watch } from "vue";
import { useRegisterSW } from "virtual:pwa-register/vue";
import { alertController } from "@ionic/vue";

export function usePWAUpdate() {
	const updateAvailable = ref(false);

	const { needRefresh, updateServiceWorker } = useRegisterSW();

	const refreshPWA = async () => {
		const alert = await alertController.create({
			header: "Restart to update",
			buttons: [
				{
					text: "Cancel",
					role: "cancel",
				},
				{
					text: "Continue",
					handler: async () => {
						await alert.dismiss();
						updateServiceWorker(true);
					},
				},
			],
		});
		await alert.present();
	};

	watch(
		needRefresh,
		(newValue) => {
			updateAvailable.value = newValue;
		},
		{ immediate: true },
	);

	return {
		updateAvailable,
		refreshPWA,
	};
}
